/**
 * Converts any value to a proper Error object with a stack trace.
 * This is used to handle errors that may not be Error instances,
 * such as rejected promises with non-Error values or caught exceptions.
 */
export function ensureError(value: unknown): Error {
  if (value instanceof Error) {
    return value
  }

  let message: string
  if (typeof value === 'string') {
    message = value
  } else if (value === undefined) {
    message = 'Unknown error (undefined)'
  } else if (value === null) {
    message = 'Unknown error (null)'
  } else {
    try {
      message = JSON.stringify(value)
    } catch {
      message = `[unserializable ${typeof value}]`
    }
  }

  return new Error(message)
}
